export default () => {
  for (const element of document.querySelectorAll(".header__dropdown > nav > ul > li > .header__parent")) {
    element.addEventListener("click", () => {
      for (const subElement of document.querySelectorAll(".header__dropdown > nav > ul > li > .header__parent")) {
        if (subElement !== element) {
          subElement.classList.remove('active')
        }
      }
    });
  }
}
